/* corex-munequera-editor.js · Personalizador de muñequeras (sections/munequera-personalizador.liquid): interfaz.
   Estado inmutable en `design` (corex-munequera-model.js); dibujo en corex-munequera-draw.js; pedido en
   corex-munequera-cart.js. Puntero como el de calcetines: mover, escalar y girar con asas, pellizco en móvil. */
(function () {
  'use strict';

  var M = window.CorexMunequeraModel;
  var D = window.CorexMunequeraDraw;
  var C = window.CorexMunequeraCart;
  var IO = window.CorexMunequeraIO;
  var P = window.CorexMunequeraPattern;
  var R = window.CorexMunequeraReview;
  var F = window.CorexTextilFonts;
  var EDITOR_PAD_MM = 4;
  var SCALE_MIN = 10;
  var SCALE_MAX = 400;
  var STATUS_MS = 6000;
  var ADD_OK_MS = 5000;
  var OFFER_KEY = 'cxm-offer-shown';
  var PHOTO_RATIO = 3215 / 2036;
  /* Lado mayor de la miniatura de un motivo en pantalla; el archivo de impresión usa siempre el original. */
  var MOTIF_THUMB_PX = 384;

  function init(root) {
    if (root.dataset.cxmReady) return;
    root.dataset.cxmReady = '1';
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var product;
    try { product = JSON.parse(q('[data-cxm-product]').textContent); } catch (err) { root.setAttribute('data-cxm-error', 'datos'); return; }
    var variants = product.variants;
    var isB2B = !!product.b2b;
    /* Tramos con mínimo (ajuste de la sección). JSON no válido: se avisa y se usan los precios del catálogo. */
    product.tramos = null;
    var tramosEl = q('[data-cxm-tramos]');
    if (tramosEl) {
      try {
        var tr = JSON.parse(tramosEl.textContent);
        if (M.b2bQuote(tr, 0, 0)) product.tramos = tr;
      } catch (err) { /* abajo */ }
      if (!product.tramos) {
        /* Se quedan los campos de pares (el pedido sigue siendo posible) y se quita lo que depende de los tramos. */
        qa('[data-cxm-b2b-tramos] .cxm-b2b__notice, [data-cxm-tiers], [data-cxm-b2b-tramos] .cxm-b2b__count, [data-cxm-b2b-normal]').forEach(function (el) { el.hidden = true; });
        root.setAttribute('data-cxm-error', 'tramos');
      }
    }
    var design = M.newDesign();
    var ui = { face: 'F', selectedId: null, qty: 1, layersOpen: false, variantId: product.initialVariantId };
    var images = {};
    var photos = {};
    var editorCanvas = q('[data-cxm-editor]');
    var metrics = null;
    var frame = null;
    var statusTimer = null;

    /* ---------- datos ---------- */
    function variant() { return variants.filter(function (v) { return v.id === ui.variantId; })[0] || variants[0]; }
    function modelOf(v) { return { key: v.key, label: v.title, photo: photos[v.key] || null, area: product.photos[v.key].area }; }
    function face() { return design.faces[ui.face]; }
    function selectedLayer() {
      var f = face();
      return f ? f.layers.filter(function (l) { return l.id === ui.selectedId; })[0] || null : null;
    }
    function getImage(src) {
      if (!images[src]) {
        var img = new Image();
        img.onload = requestRender;
        img.src = src;
        images[src] = img;
      }
      return images[src];
    }
    /* Miniatura reducida por pasos (buena calidad) para pintar el patrón en pantalla sin redimensionar el original
       cientos de veces por fotograma (como calcetines). */
    var motifThumbs = {};
    function scaledCopy(source, w, h) {
      var c = document.createElement('canvas');
      c.width = w;
      c.height = h;
      var ctx = c.getContext('2d');
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(source, 0, 0, w, h);
      return c;
    }
    function getMotif(src) {
      if (motifThumbs[src]) return motifThumbs[src];
      var img = getImage(src);
      if (!P.isDrawable(img)) return null;
      var scale = Math.min(1, MOTIF_THUMB_PX / Math.max(img.naturalWidth, img.naturalHeight));
      if (scale === 1) return (motifThumbs[src] = img);
      var source = img, w = img.naturalWidth, h = img.naturalHeight;
      var tw = Math.max(1, Math.round(w * scale)), th = Math.max(1, Math.round(h * scale));
      while (w / 2 > tw) { w = Math.round(w / 2); h = Math.round(h / 2); source = scaledCopy(source, w, h); }
      return (motifThumbs[src] = scaledCopy(source, tw, th));
    }
    function loadPhotos() {
      Object.keys(product.photos).forEach(function (k) {
        C.loadImage(product.photos[k].url).then(function (img) { photos[k] = img; layout(); }, function () { /* sin foto: vista plana */ });
      });
    }
    function announce(msg) {
      var el = q('[data-cxm-status]');
      el.textContent = msg;
      clearTimeout(statusTimer);
      statusTimer = setTimeout(function () { el.textContent = ''; }, STATUS_MS);
    }

    /* ---------- cambios del diseño ---------- */
    /* Cualquier cambio del diseño pide volver a confirmarlo: la property «Revisión» se refiere a la versión final. */
    function setDesign(next) {
      var prev = design;
      design = next;
      if (confirmBox) confirmBox.checked = false;
      maybeOffer(prev, next);
      var msg = q('[data-cxm-cartmsg]');
      if (msg.classList.contains('is-error')) msg.hidden = true;
      requestRender();
    }
    function updateSelected(patch) { var l = selectedLayer(); if (l) setDesign(M.updateLayer(design, ui.face, l.id, patch)); }
    function frontKeys(d) { return d.mode === 'iguales' ? ['F'] : ['AF', 'BF']; }
    function backKeys(d) { return d.mode === 'iguales' ? ['T'] : ['AT', 'BT']; }
    function imageCount(d, keys) {
      return keys.reduce(function (n, k) { return n + d.faces[k].layers.filter(function (l) { return l.type === 'image'; }).length; }, 0);
    }
    /* «¿Usar el mismo diseño en la trasera?»: con la primera imagen en una frontal y las traseras vacías, una vez por sesión. */
    function maybeOffer(prev, next) {
      var box = q('[data-cxm-offer]');
      var backsEmpty = backKeys(next).every(function (k) { return !M.faceHasContent(next.faces[k]); });
      if (!box.hidden && (!backsEmpty || next.caras !== 'ambas' || prev.mode !== next.mode)) box.hidden = true;
      if (next.caras !== 'ambas' || prev.mode !== next.mode || !backsEmpty) return;
      if (imageCount(prev, frontKeys(next)) > 0 || imageCount(next, frontKeys(next)) === 0) return;
      try { if (sessionStorage.getItem(OFFER_KEY)) return; sessionStorage.setItem(OFFER_KEY, '1'); } catch (err) { /* sin almacenamiento */ }
      box.hidden = false;
    }

    /* ---------- medidas y dibujo ---------- */
    function cssNumber(name, fallback) {
      var v = parseFloat(getComputedStyle(root).getPropertyValue(name));
      return isNaN(v) ? fallback : v;
    }
    function layout() {
      metrics = D.sizeEditor(editorCanvas, cssNumber('--cxm-editor-w', 280), EDITOR_PAD_MM);
      var pw = cssNumber('--cxm-preview-w', 110), dpr = Math.min(window.devicePixelRatio || 1, 3);
      var photo = photos[variant().key];
      var ratio = photo ? photo.naturalHeight / photo.naturalWidth : PHOTO_RATIO;
      var mini = q('[data-cxm-mini]'), mw = cssNumber('--cxm-mini-w', 64);
      mini.style.width = mw + 'px';
      mini.style.height = Math.round(mw * ratio) + 'px';
      mini.width = Math.round(mw * dpr);
      mini.height = Math.round(mw * ratio * dpr);
      qa('[data-cxm-preview]').forEach(function (c) {
        c.style.width = pw + 'px';
        c.style.height = Math.round(pw * ratio) + 'px';
        c.width = Math.round(pw * dpr);
        c.height = Math.round(pw * ratio * dpr);
      });
      requestRender();
    }
    function requestRender() {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = null; render(); });
    }
    function render() {
      if (!metrics) return;
      var l = selectedLayer();
      var warn = l ? M.outsideSafe(l, D.layerSize(l)) : false;
      D.drawEditor(editorCanvas, Object.assign({ face: face(), selected: l, warn: warn, getImage: getImage, getMotif: getMotif }, metrics));
      var model = modelOf(variant());
      qa('[data-cxm-preview]').forEach(function (c) {
        var zone = M.ZONES.filter(function (z) { return z.zone === c.getAttribute('data-cxm-preview'); })[0];
        if (zone.back && design.caras !== 'ambas') return;
        D.drawPhotoFace(c, design.faces[M.faceKeyFor(design.mode, zone)], model.photo, model.area, getImage, getMotif);
      });
      var mini = q('[data-cxm-mini]');
      if (mini.offsetParent) D.drawPhotoFace(mini, face(), model.photo, model.area, getImage, getMotif);
      qa('[data-cxm-preview-back]').forEach(function (el) { el.hidden = design.caras !== 'ambas'; });
      R.markTabs(q('[data-cxm-tabs]'), M.designIssues(design, D.layerSize));
      syncPanel(l);
      syncLayers();
      syncPattern();
      syncBackground();
    }

    /* ---------- sincronización de controles ---------- */
    /* Solo si cambia: los avisos son regiones vivas y un lector de pantalla los repetiría en cada fotograma. */
    function setText(el, text) { if (el.textContent !== text) el.textContent = text; }
    function setActive(selector, attr, value) {
      qa(selector).forEach(function (b) {
        var on = b.getAttribute(attr) === String(value);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', String(on));
      });
    }
    function syncChoices() {
      setActive('[data-cxm-variant]', 'data-cxm-variant', ui.variantId);
      setActive('[data-cxm-mode]', 'data-cxm-mode', design.mode);
      setActive('[data-cxm-format]', 'data-cxm-format', design.format);
      root.setAttribute('data-cxm-fmt', design.format);
      fileInput.multiple = design.format === 'patron';
      setActive('[data-cxm-caras]', 'data-cxm-caras', design.caras);
      var tabs = M.visibleTabs(design);
      if (!tabs.some(function (t) { return t.id === ui.face; })) { ui.face = tabs[0].id; ui.selectedId = null; }
      var el = q('[data-cxm-tabs]');
      el.textContent = '';
      tabs.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cxm-tab' + (t.id === ui.face ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', String(t.id === ui.face));
        b.setAttribute('data-cxm-tab', t.id);
        b.textContent = t.label;
        b.title = t.long;
        el.appendChild(b);
      });
      q('[data-cxm-copy-back]').hidden = design.caras !== 'ambas';
      q('[data-cxm-copy-all]').hidden = tabs.length < 2;
      syncPrice();
      requestRender();
    }
    function syncPrice() {
      var v = variant();
      var sum = v.title + ' · ' + M.MODE_LABEL[design.mode] + ' · ' + M.CARAS_LABEL[design.caras];
      q('[data-cxm-summary]').textContent = sum;
      q('[data-cxm-summary-short]').textContent = v.title + ' · ' + M.MODE_LABEL[design.mode];
      var quote = isB2B ? M.b2bQuote(product.tramos, b2bTotal(), v.pvp) : null;
      qa('[data-cxm-price]').forEach(function (el) { el.textContent = quote ? formatEur(quote.cents) : v.priceFormatted; });
      qa('[data-cxm-atc]').forEach(function (b) {
        if (b.hasAttribute('aria-busy')) return;
        var off = isB2B ? b2bTotal() === 0 : !v.available;
        b.setAttribute('aria-disabled', String(off));
        b.textContent = !isB2B && !v.available ? 'No disponible' : 'Añadir al carrito';
      });
      if (isB2B) syncTiers();
    }
    function syncPanel(l) {
      var kind = l ? l.type : 'none';
      q('[data-cxm-panel]').setAttribute('data-kind', kind);
      q('[data-cxm-panel-title]').textContent = kind === 'text' ? 'Texto seleccionado' : kind === 'image' ? 'Imagen seleccionada' : 'Selecciona una imagen o un texto';
      var scale = q('[data-cxm-scale]'), rot = q('[data-cxm-rotate]');
      if (document.activeElement !== scale) scale.value = l ? String(Math.round(l.scale * 100)) : '100';
      if (document.activeElement !== rot) rot.value = l ? String(Math.round(l.rotation)) : '0';
      q('[data-cxm-scale-value]').textContent = (l ? Math.round(l.scale * 100) : 100) + '%';
      q('[data-cxm-rotate-value]').textContent = (l ? Math.round(l.rotation) : 0) + '°';
      qa('[data-cxm-panel] input, [data-cxm-panel] select, [data-cxm-panel] button').forEach(function (el) { el.disabled = !l; });
      q('[data-cxm-cover]').disabled = !l || l.type !== 'image';
      q('[data-cxm-fit]').disabled = !l || l.type !== 'image';
      q('[data-cxm-textfields]').hidden = kind !== 'text';
      if (kind === 'text') {
        var input = q('[data-cxm-text]');
        if (document.activeElement !== input) input.value = l.text;
        qa('[data-cxm-fontkey]').forEach(function (b) {
          var on = b.getAttribute('data-cxm-fontkey') === l.fontKey;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', String(on));
        });
        q('[data-cxm-color]').value = l.color;
      }
      var dpi = l ? M.effectiveDpi(l) : null;
      var quality = q('[data-cxm-quality]');
      quality.hidden = !(dpi && dpi < M.LOW_DPI);
      setText(quality, dpi ? 'Resolución baja a este tamaño (~' + Math.round(dpi) + ' ppp): puede salir pixelada. Usa una imagen más grande o redúcela.' : '');
      var edge = l ? M.edgeLevel(l, D.layerSize(l)) : null, outside = q('[data-cxm-outside]');
      outside.hidden = !edge;
      setText(outside, R.edgeText(edge));
      outside.setAttribute('data-level', edge || '');
    }
    var lastLayersSig = '';
    function syncLayers() {
      var layers = face().layers;
      var sig = ui.face + '|' + ui.selectedId + '|' + layers.map(function (l) { return l.id + (l.text || ''); }).join(',');
      if (sig === lastLayersSig) return;
      lastLayersSig = sig;
      var list = q('[data-cxm-layers]');
      list.textContent = '';
      q('[data-cxm-layers-empty]').hidden = layers.length > 0;
      layers.slice().reverse().forEach(function (l, i) {
        var li = document.createElement('li');
        li.className = 'cxm-layer' + (l.id === ui.selectedId ? ' is-active' : '');
        var pick = document.createElement('button');
        pick.type = 'button';
        pick.className = 'cxm-layer__pick';
        pick.setAttribute('data-cxm-layer-select', l.id);
        var thumb = document.createElement(l.type === 'image' ? 'img' : 'span');
        thumb.className = 'cxm-layer__thumb';
        if (l.type === 'image') { thumb.src = l.src; thumb.alt = ''; } else { thumb.textContent = 'T'; }
        var name = document.createElement('span');
        name.textContent = l.type === 'image' ? l.name : '«' + l.text + '»';
        pick.appendChild(thumb);
        pick.appendChild(name);
        li.appendChild(pick);
        [['up', '↑', 'Subir capa', i === 0], ['down', '↓', 'Bajar capa', i === layers.length - 1], ['remove', '✕', 'Quitar capa', false]].forEach(function (a) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cxm-layer__act';
          b.textContent = a[1];
          b.setAttribute('aria-label', a[2]);
          b.setAttribute('data-cxm-layer-' + a[0], l.id);
          b.disabled = a[3];
          li.appendChild(b);
        });
        list.appendChild(li);
      });
    }
    function setSlider(name, range, value, text) {
      var input = q('[data-cxm-' + name + ']');
      input.min = String(range.min);
      input.max = String(range.max);
      input.step = String(range.step);
      if (document.activeElement !== input) input.value = String(value);
      q('[data-cxm-' + name + '-value]').textContent = text;
    }
    var lastThumbsSig = '';
    function syncPattern() {
      var p = face().pattern;
      if (design.format !== 'patron' || !p) return;
      setSlider('psize', P.SIZE, p.sizeMm, p.sizeMm + ' mm');
      setSlider('pgap', P.GAP, p.gapMm, p.gapMm + ' mm');
      setSlider('prot', P.ROT, p.rotation, p.rotation + '°');
      setActive('[data-cxm-ptpl]', 'data-cxm-ptpl', p.template);
      q('[data-cxm-shuffle]').hidden = p.template !== 'aleatorio';
      var low = P.lowDpiImages(p, M.LOW_DPI), warn = q('[data-cxm-pquality]');
      warn.hidden = !low.length;
      warn.textContent = low.length ? 'Resolución baja a ' + p.sizeMm + ' mm: ' + low.map(function (x) { return '«' + x.name + '» (~' + Math.round(x.dpi) + ' ppp)'; }).join(', ') + '. Puede salir pixelada; prueba un motivo más pequeño o una imagen más grande.' : '';
      var sig = ui.face + '|' + p.images.map(function (im) { return im.id; }).join(',');
      if (sig === lastThumbsSig) return;
      lastThumbsSig = sig;
      var list = q('[data-cxm-pimages]');
      list.textContent = '';
      p.images.forEach(function (im) {
        var item = document.createElement('div');
        item.className = 'cxm-pthumb';
        var img = document.createElement('img');
        img.src = im.src;
        img.alt = im.name;
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'cxm-pthumb__x';
        x.textContent = '×';
        x.setAttribute('aria-label', 'Quitar ' + im.name);
        x.setAttribute('data-cxm-pimg-remove', im.id);
        item.appendChild(img);
        item.appendChild(x);
        list.appendChild(item);
      });
      if (p.images.length < P.MAX_IMAGES) {
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'cxm-pthumb cxm-pthumb--add';
        add.textContent = '+';
        add.setAttribute('aria-label', p.images.length ? 'Añadir otra imagen' : 'Subir imagen');
        add.setAttribute('data-cxm-upload', '');
        list.appendChild(add);
      }
    }
    var lastHexSig = '';
    function syncBackground() {
      var bg = face().background.toUpperCase();
      qa('[data-cxm-bg]').forEach(function (b) {
        var on = b.getAttribute('data-cxm-bg').toUpperCase() === bg;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', String(on));
      });
      var sig = ui.face + '|' + bg;
      if (sig === lastHexSig) return;
      lastHexSig = sig;
      q('[data-cxm-hex]').value = bg;
      q('[data-cxm-hex-err]').hidden = true;
    }
    function commitHex() {
      var hex = M.parseHex(q('[data-cxm-hex]').value);
      q('[data-cxm-hex-err]').hidden = !!hex;
      if (hex && hex !== face().background.toUpperCase()) setDesign(M.patchFace(design, ui.face, { background: hex }));
    }

    /* ---------- B2B ---------- */
    function b2bLines() {
      return qa('[data-cxm-b2b-qty]').map(function (input) {
        var n = Math.floor(Number(input.value));
        return { variantId: Number(input.getAttribute('data-cxm-b2b-qty')), qty: isFinite(n) && n > 0 ? Math.min(n, 9999) : 0, min: Number(input.getAttribute('data-cxm-b2b-min')) || 1 };
      });
    }
    function b2bTotal() { return b2bLines().reduce(function (s, l) { return s + l.qty; }, 0); }
    function formatEur(cents) { return (cents / 100).toFixed(2).replace('.', ',') + '€'; }
    /* Tramos con mínimo (metafield corex.b2b_tramos): tabla, contador y aviso, como calcetines. */
    var lastTramosSig = '';
    function syncTramos() {
      var pvp = variant().pvp, quote = M.b2bQuote(product.tramos, b2bTotal(), pvp);
      var sig = quote.pairs + '|' + pvp;
      if (sig === lastTramosSig) return;
      lastTramosSig = sig;
      var table = q('[data-cxm-tiers]');
      table.textContent = '';
      var row = function (a, b, current, head) {
        var r = document.createElement('div');
        r.className = 'cxm-tier' + (current ? ' is-row' : '') + (head ? ' cxm-tier--head' : '');
        r.setAttribute('role', 'row');
        [a, b].forEach(function (t, i) {
          var c = document.createElement('span');
          c.setAttribute('role', head ? 'columnheader' : i ? 'cell' : 'rowheader');
          c.textContent = t;
          r.appendChild(c);
        });
        table.appendChild(r);
      };
      row('Pares en el pedido', 'Precio por par', false, true);
      row('Menos de ' + quote.min, formatEur(pvp) + ' (PVP)', quote.pairs > 0 && !quote.tier);
      product.tramos.tiers.forEach(function (t, i, all) {
        var next = all[i + 1];
        row(next ? t.min + '–' + (next.min - 1) : t.min + '+', formatEur(Math.round(t.price * 100)), quote.tier === t);
      });
      q('[data-cxm-b2b-min-text]').textContent = 'Mínimo ' + quote.min + ' pares por diseño para precio profesional.';
      var count = q('[data-cxm-b2b-count]');
      var ok = !quote.missing;
      count.closest('.cxm-b2b__count').classList.toggle('is-ok', ok);
      count.textContent = ok ? '✓ Precio profesional desde ' + quote.min + ' pares' : quote.pairs + ' de ' + quote.min + ' pares · faltan ' + quote.missing + ' para precio profesional';
      q('[data-cxm-b2b-fill]').style.width = Math.min(100, quote.pairs / quote.min * 100) + '%';
      var normal = q('[data-cxm-b2b-normal]');
      normal.hidden = ok;
      normal.textContent = 'Con menos de ' + quote.min + ' pares por diseño se aplica el PVP (' + formatEur(pvp) + ' el par).';
    }
    /* Sin tramos propios: resalta el corte de precio del catálogo que corresponde a cada modelo (lo aplica Shopify). */
    function syncTiers() {
      if (product.tramos) return syncTramos();
      b2bLines().forEach(function (line) {
        var rows = qa('[data-cxm-tier="' + line.variantId + '"]');
        var best = null;
        rows.forEach(function (r) { if (line.qty >= Number(r.getAttribute('data-min'))) best = r; });
        rows.forEach(function (r) { r.classList.toggle('is-row', r === best && line.qty > 0); });
      });
    }

    /* ---------- acciones ---------- */
    function selectFace(id) { ui.face = id; ui.selectedId = null; syncChoices(); }
    function selectVariant(id) {
      ui.variantId = Number(id);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', ui.variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* sin historial: solo cambia la vista */ }
      layout();
      syncChoices();
    }
    /* Imagen libre: una capa con las medidas reales del archivo (corex-munequera-io.js + model.placeImage). */
    function readFile(file) {
      if (!file) return;
      var key = ui.face;
      announce(IO.isPdf(file) ? 'Cargando PDF…' : 'Cargando imagen…');
      IO.readDesignFile(file).then(function (r) {
        images[r.src] = r.img;
        var layer = M.imageLayer(r.name, r.src, r);
        setDesign(M.addLayer(design, key, layer));
        if (!M.isBackdrop(layer) && design.faces[key].background.toUpperCase() === M.WHITE) bgColor.offerFor(r.img, function (hex) { setDesign(M.patchFace(design, key, { background: hex })); });
        if (key === ui.face) ui.selectedId = layer.id;
        var size = (Math.round(layer.width * D.layerSize(layer).h / D.layerSize(layer).w) / 10).toString().replace('.', ',');
        var msg = layer.template ? 'Tu diseño tiene la medida de la plantilla: colocado a tamaño real y en su sitio. Si se ven las líneas de la plantilla, se imprimirán: quítalas antes de exportar.'
          : layer.physical ? 'Imagen añadida a su tamaño real (' + String(Math.round(layer.width) / 10).replace('.', ',') + ' × ' + size + ' cm).'
            : 'Imagen añadida. Arrástrala para colocarla o usa «Cubrir toda la cara».';
        announce(msg + (r.pages > 1 ? ' Del PDF solo se usa la primera página.' : ''));
      }, function (err) { announce(err && err.userFacing ? err.message : 'No se ha podido leer el archivo.'); });
    }
    /* Patrón: varias imágenes a la vez, en orden, sobre la cara activa al empezar. */
    var patternBusy = false;
    function readPatternFiles(files) {
      if (!files.length || patternBusy) return;
      var key = ui.face, added = 0, lastError = null, multiPage = false;
      patternBusy = true;
      announce('Cargando…');
      var chain = Promise.resolve();
      files.forEach(function (file) {
        chain = chain.then(function () {
          if (design.faces[key].pattern.images.length >= P.MAX_IMAGES) return;
          return IO.readDesignFile(file).then(function (r) {
            images[r.src] = r.img;
            if (r.pages > 1) multiPage = true;
            setDesign(M.addPatternImage(design, key, { name: r.name, src: r.src, naturalWidth: r.naturalWidth, naturalHeight: r.naturalHeight }));
            added++;
          }, function (err) { lastError = err; });
        });
      });
      chain.then(function () {
        patternBusy = false;
        var parts = [];
        if (added) parts.push(added === 1 ? 'Imagen añadida al patrón.' : added + ' imágenes añadidas al patrón.');
        if (multiPage) parts.push('Del PDF solo se usa la primera página.');
        if (added < files.length && design.faces[key].pattern.images.length >= P.MAX_IMAGES) parts.push('Máximo ' + P.MAX_IMAGES + ' imágenes por cara.');
        if (lastError) parts.push(lastError.userFacing ? lastError.message : 'No se ha podido leer uno de los archivos.');
        announce(parts.join(' '));
      });
    }
    function selectFormat(format) {
      if (format === design.format) return;
      var hasDesign = M.visibleTabs(design).some(function (t) { return M.faceHasContent(design.faces[t.id]); });
      var ask = hasDesign ? confirmModal('Al cambiar de formato se empieza de cero y se perderá el diseño actual. ¿Continuar?') : Promise.resolve(true);
      ask.then(function (ok) {
        if (!ok) return;
        ui.selectedId = null;
        setDesign(M.withFormat(design, format));
        lastThumbsSig = '';
        syncChoices();
      });
    }
    function addText() {
      var layer = M.textLayer(F.DEFAULT_KEY);
      setDesign(M.addLayer(design, ui.face, layer));
      ui.selectedId = layer.id;
      F.ensure(layer.fontKey, layer.text).then(requestRender, function () { /* se dibuja con la de reserva */ });
      requestAnimationFrame(function () {
        var input = q('[data-cxm-text]');
        if (input && input.offsetParent) { input.focus(); input.select(); }
      });
    }
    function setFont(key) {
      var l = selectedLayer();
      if (!l || l.type !== 'text') return;
      updateSelected({ fontKey: key });
      F.ensure(key, l.text).then(requestRender, function (err) { announce(err.message); });
    }

    /* ---------- modal y mensajes ---------- */
    var confirmModal = R.createModal(q('[data-cxm-modal]'));
    var cartMsgTimer = null;
    function showCartMsg(text, tone) {
      clearTimeout(cartMsgTimer);
      var el = q('[data-cxm-cartmsg]');
      el.textContent = text;
      el.className = 'cxm-cartmsg is-' + tone;
      el.hidden = false;
      if (tone === 'ok') cartMsgTimer = setTimeout(function () { el.hidden = true; }, ADD_OK_MS);
      if (window.matchMedia('(max-width: 989px)').matches) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function setBusy(text) {
      qa('[data-cxm-atc]').forEach(function (b) {
        b.disabled = !!text;
        if (text) { b.textContent = text; b.setAttribute('aria-busy', 'true'); } else b.removeAttribute('aria-busy');
      });
      if (!text) syncPrice();
    }

    /* ---------- pedido ---------- */
    function ensureReady() {
      var tabs = M.visibleTabs(design), srcs = [], texts = [];
      tabs.forEach(function (t) {
        var f = design.faces[t.id];
        f.layers.forEach(function (l) { if (l.type === 'image') srcs.push(l.src); else texts.push(l); });
        if (f.pattern) f.pattern.images.forEach(function (im) { srcs.push(im.src); });
      });
      return Promise.all(srcs.map(function (src) {
        var img = getImage(src);
        return img.complete && img.naturalWidth ? img : new Promise(function (res, rej) { img.addEventListener('load', res, { once: true }); img.addEventListener('error', rej, { once: true }); });
      }).concat([F.ensureLayers(texts)]));
    }
    function headFont() { return getComputedStyle(root).getPropertyValue('--main_ff_h').trim() || 'sans-serif'; }
    function cartLines() {
      if (!isB2B) {
        var v = variant();
        if (!v.available) return { error: 'Este modelo no está disponible ahora mismo.' };
        return { lines: [{ variantId: v.id, quantity: ui.qty, model: modelOf(v) }] };
      }
      var wanted = b2bLines().filter(function (l) { return l.qty > 0; });
      if (!wanted.length) return { error: 'Indica cuántos pares quieres de cada modelo.' };
      var short = wanted.filter(function (l) { return l.qty < l.min; });
      if (short.length) return { error: 'El mínimo por modelo es ' + short[0].min + ' pares.' };
      return {
        lines: wanted.map(function (l) {
          var v = variants.filter(function (x) { return x.id === l.variantId; })[0];
          return { variantId: v.id, quantity: l.qty, model: modelOf(v) };
        })
      };
    }
    /* Lleva al cliente a la cara (y al elemento) del primer aviso. */
    function goToIssue(issue) {
      selectFace(issue.faceKey);
      ui.selectedId = issue.layerId;
      requestRender();
      editorCanvas.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var confirmBox = q('[data-cxm-confirm]');
    confirmBox.addEventListener('change', function () {
      confirmBox.closest('.cxm-confirm').classList.remove('is-error');
      if (confirmBox.checked && q('[data-cxm-cartmsg]').classList.contains('is-error')) q('[data-cxm-cartmsg]').hidden = true;
    });
    var cartBusy = false;
    /* Antes de subir nada: casilla de confirmación y, si hay avisos (bordes, resolución, caras en blanco), la lista con
       «Revisar diseño» o «Añadir igualmente». La property «Revisión» deja constancia en el pedido. */
    function addToCart() {
      if (cartBusy) return;
      var plan = cartLines();
      if (plan.error) return showCartMsg(plan.error, 'error');
      if (M.isEmpty(design)) return showCartMsg('Añade al menos una imagen, un texto o un color de fondo antes de añadir al carrito.', 'error');
      if (!confirmBox.checked) {
        confirmBox.closest('.cxm-confirm').classList.add('is-error');
        confirmBox.focus({ preventScroll: true });
        confirmBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return showCartMsg('Marca la casilla «He revisado mi diseño» antes de añadir al carrito.', 'error');
      }
      var issues = M.designIssues(design, D.layerSize);
      var ask = issues.length ? confirmModal('Revisa tu diseño antes de añadirlo al carrito:', { items: R.itemsOf(issues), back: 'Revisar diseño', ok: 'Añadir igualmente' }) : Promise.resolve(true);
      ask.then(function (ok) {
        if (!ok) return goToIssue(issues[0]);
        cartBusy = true;
        q('[data-cxm-cartmsg]').hidden = true;
        C.addDesignToCart({
          design: design, lines: plan.lines, getImage: getImage, ensureReady: ensureReady, review: M.reviewNote(issues),
          headFont: headFont(), bodyFont: getComputedStyle(root).fontFamily || 'sans-serif', onProgress: setBusy
        }).then(function () { confirmBox.checked = false; showCartMsg('✓ Añadido al carrito', 'ok'); }, function (err) {
          showCartMsg(err && err.userFacing ? err.message : 'No se ha podido preparar tu diseño. Inténtalo de nuevo.', 'error');
        }).then(function () { cartBusy = false; setBusy(null); });
      });
    }
    function saveBlob(blob, name) {
      var url = URL.createObjectURL(blob), a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    }
    function downloadPreview(link) {
      if (link.getAttribute('aria-busy') === 'true') return;
      var original = link.textContent;
      link.setAttribute('aria-busy', 'true');
      link.textContent = 'Generando…';
      ensureReady().then(function () {
        return C.previewJpg({ design: design, model: modelOf(variant()), getImage: getImage, headFont: headFont(), bodyFont: getComputedStyle(root).fontFamily });
      }).then(function (jpg) { saveBlob(jpg, 'vista-previa-munequeras-corex.jpg'); }, function () {
        announce('No se ha podido generar la imagen. Inténtalo de nuevo.');
      }).then(function () { link.textContent = original; link.removeAttribute('aria-busy'); });
    }
    function downloadTemplate(link) {
      fetch(link.href).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); })
        .then(function (b) { saveBlob(b, 'plantilla-munequera-corex-9x15.png'); }, function () { window.open(link.href, '_blank', 'noopener'); });
    }

    /* ---------- eventos ---------- */
    window.CorexMunequeraPointer.attach(editorCanvas, {
      metrics: function () { return metrics; },
      layers: function () { return face().layers; },
      selected: selectedLayer,
      select: function (id) { ui.selectedId = id; requestRender(); },
      update: updateSelected,
      remove: function (id) { ui.selectedId = null; setDesign(M.removeLayer(design, ui.face, id)); },
      scaleRange: function () { return { min: SCALE_MIN / 100, max: Number(q('[data-cxm-scale]').max) / 100 }; }
    });
    /* Fondo con el color de la imagen: botón, cuentagotas y oferta al subir (corex-munequera-color.js). */
    var bgColor = window.CorexMunequeraColor.attach({
      root: root, canvas: editorCanvas, getImage: getImage, announce: announce,
      imageLayer: function () {
        var l = selectedLayer(), f = face();
        return (l && l.type === 'image' ? l : f.layers.filter(function (x) { return x.type === 'image'; }).pop()) || (f.pattern && f.pattern.images[0]) || null;
      },
      setBackground: function (hex) { setDesign(M.patchFace(design, ui.face, { background: hex })); }
    });
    var fileInput = q('[data-cxm-file]');
    fileInput.addEventListener('change', function () {
      var files = Array.prototype.slice.call(fileInput.files || []);
      fileInput.value = '';
      if (design.format === 'patron') return readPatternFiles(files);
      readFile(files[0]);
    });
    [['psize', 'sizeMm'], ['pgap', 'gapMm'], ['prot', 'rotation']].forEach(function (sl) {
      q('[data-cxm-' + sl[0] + ']').addEventListener('input', function (e) {
        var patch = {};
        patch[sl[1]] = Number(e.target.value);
        setDesign(M.patchPattern(design, ui.face, patch));
      });
    });
    /* Fuentes: las rápidas siempre; el resto con «Más fuentes». Cada botón se pinta con su fuente (recorte con las letras
       de su nombre) en cuanto carga. */
    var fontsEl = q('[data-cxm-fonts]');
    function fontButton(f, extra) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cxm-font' + (extra ? ' cxm-font--extra' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.setAttribute('data-cxm-fontkey', f.key);
      b.textContent = f.name;
      if (extra) b.hidden = true;
      return b;
    }
    F.QUICK.concat(F.FONTS.map(function (f) { return f.key; }).filter(function (k) { return F.QUICK.indexOf(k) === -1; }))
      .forEach(function (k, i) { fontsEl.appendChild(fontButton(F.get(k), i >= F.QUICK.length)); });
    function paintFontButtons(onlyVisible) {
      qa('[data-cxm-fontkey]').forEach(function (b) {
        if (onlyVisible && b.hidden) return;
        var k = b.getAttribute('data-cxm-fontkey');
        F.loadPreview(k).then(function () { b.style.fontFamily = F.previewFamily(k); }, function () { /* se queda con la del tema */ });
      });
    }
    q('[data-cxm-text]').addEventListener('input', function (e) {
      var l = selectedLayer();
      if (!l) return;
      updateSelected({ text: e.target.value });
      F.ensure(l.fontKey, e.target.value).then(requestRender, function () { /* reserva */ });
    });
    q('[data-cxm-color]').addEventListener('input', function (e) { updateSelected({ color: e.target.value }); });
    q('[data-cxm-scale]').addEventListener('input', function (e) { updateSelected({ scale: Number(e.target.value) / 100 }); });
    q('[data-cxm-rotate]').addEventListener('input', function (e) { updateSelected({ rotation: Number(e.target.value) }); });
    var hex = q('[data-cxm-hex]');
    hex.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); commitHex(); } });
    hex.addEventListener('blur', commitHex);
    if (isB2B) {
      root.addEventListener('input', function (e) { if (e.target.hasAttribute('data-cxm-b2b-qty')) syncPrice(); });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      var a = function (name) { return t.getAttribute('data-cxm-' + name); };
      var has = function (name) { return t.hasAttribute('data-cxm-' + name); };
      var l = selectedLayer();
      if (has('variant')) return selectVariant(a('variant'));
      if (has('format')) return selectFormat(a('format'));
      if (has('pimg-remove')) return setDesign(M.removePatternImage(design, ui.face, a('pimg-remove')));
      if (has('ptpl') && P.TEMPLATES.indexOf(a('ptpl')) !== -1) return setDesign(M.patchPattern(design, ui.face, { template: a('ptpl') }));
      if (has('shuffle')) return setDesign(M.patchPattern(design, ui.face, { seed: P.newSeed() }));
      if (has('mode')) {
        if (a('mode') === 'iguales' && design.mode === 'distintas') announce('Se conserva el diseño de la muñequera A para las dos.');
        ui.selectedId = null;
        setDesign(M.withMode(design, a('mode')));
        ui.face = M.visibleTabs(design)[0].id;
        return syncChoices();
      }
      if (has('caras')) { setDesign(M.withCaras(design, a('caras'))); return syncChoices(); }
      if (has('tab')) return selectFace(a('tab'));
      if (has('fontkey')) return setFont(a('fontkey'));
      if (has('fonts-more')) {
        var open = t.getAttribute('aria-expanded') !== 'true';
        qa('.cxm-font--extra').forEach(function (b) { b.hidden = !open; });
        t.setAttribute('aria-expanded', String(open));
        t.textContent = open ? 'Menos fuentes' : 'Más fuentes';
        if (open) paintFontButtons(true);
        return;
      }
      if (has('upload')) return fileInput.click();
      if (has('add-text')) { paintFontButtons(true); return addText(); }
      if (has('layers-toggle')) {
        ui.layersOpen = !ui.layersOpen;
        q('[data-cxm-layers-panel]').hidden = !ui.layersOpen;
        t.setAttribute('aria-expanded', String(ui.layersOpen));
        return;
      }
      if (has('layer-select')) { ui.selectedId = a('layer-select'); return requestRender(); }
      if (has('layer-up')) return setDesign(M.moveLayer(design, ui.face, a('layer-up'), 1));
      if (has('layer-down')) return setDesign(M.moveLayer(design, ui.face, a('layer-down'), -1));
      if (has('layer-remove')) { if (ui.selectedId === a('layer-remove')) ui.selectedId = null; return setDesign(M.removeLayer(design, ui.face, a('layer-remove'))); }
      if (has('align') && l) return updateSelected(M.alignPatch(l, D.layerSize(l), M.GEO.safe, a('align')));
      if (has('cover') && l) {
        var cc = M.rectCenter(M.GEO.cut);
        return updateSelected({ x: cc.x, y: cc.y, rotation: 0, scale: M.coverScale(l, M.GEO.print) });
      }
      if (has('fit') && l) {
        var sc = M.rectCenter(M.GEO.safe);
        return updateSelected({ x: sc.x, y: sc.y, rotation: 0, scale: M.fitScale(l, M.GEO.safe) });
      }
      if (has('remove') && l) { ui.selectedId = null; return setDesign(M.removeLayer(design, ui.face, l.id)); }
      if (has('bg')) return setDesign(M.patchFace(design, ui.face, { background: a('bg').toUpperCase() }));
      if (has('copy-back')) { setDesign(M.copyFrontToBack(design)); return announce('Frontal copiada en la trasera.'); }
      if (has('copy-all')) { setDesign(M.copyToOthers(design, ui.face)); return announce('Esta cara se ha copiado en las demás.'); }
      if (has('offer-no')) { q('[data-cxm-offer]').hidden = true; return; }
      if (has('offer-yes')) { q('[data-cxm-offer]').hidden = true; setDesign(M.copyFrontToBack(design)); return announce('Frontal copiada en la trasera.'); }
      if (has('qty-step')) {
        ui.qty = M.clamp(ui.qty + Number(a('qty-step')), 1, 999);
        q('[data-cxm-qty]').textContent = String(ui.qty);
        return;
      }
      if (has('download')) { e.preventDefault(); return downloadPreview(t); }
      if (has('template')) { e.preventDefault(); return downloadTemplate(t); }
      if (has('atc')) return addToCart();
    });

    /* La escala máxima permite cubrir la cara aunque la imagen sea pequeña. */
    q('[data-cxm-scale]').max = String(SCALE_MAX);
    var resizeTimer = null, lastW = cssNumber('--cxm-editor-w', 280);
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var w = cssNumber('--cxm-editor-w', 280);
        if (w !== lastW) { lastW = w; layout(); }
      }, 150);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(requestRender);
    root.cxmDesigner = {
      getDesign: function () { return JSON.parse(JSON.stringify(design)); },
      renderPrint: function (key) { return D.renderPrint(design.faces[key], getImage); }
    };
    syncChoices();
    layout();
    loadPhotos();
  }

  function initAll(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cxm]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
